import React from "react";
import { Form, Select, Tag } from "antd";
import type { SelectProps } from "antd";

// Define a type for tag rendering
type TagRender = SelectProps["tagRender"];

// Map your options to colors
const optionColors: Record<string, string> = {
  appartements: "purple",
  villas: "green",
  "locaux commerciaux": "cyan",
  bureaux: "red",
};

// Custom tag rendering function
const tagRender: TagRender = (props) => {
  const { label, value, closable, onClose } = props;

  const onPreventMouseDown = (event: React.MouseEvent<HTMLSpanElement>) => {
    event.preventDefault();
    event.stopPropagation();
  };

  return (
    <Tag
      color={optionColors[value]}
      onMouseDown={onPreventMouseDown}
      closable={closable}
      onClose={onClose}
      style={{ marginInlineEnd: 4 }}
    >
      {label}
    </Tag>
  );
};

interface Props {
  form: any;
}

const ComposantsDeProjetFormItem: React.FC<Props> = ({ form }: any) => (
  <Form.Item
    name="composants"
    label="Composants de projet"
    rules={[
      {
        required: true,
        message: "Veuillez saisir les composants du projets",
      },
    ]}
  >
    <Select mode="multiple" tagRender={tagRender} style={{ width: "100%" }}>
      <Select.Option value="appartements">Appartements</Select.Option>
      <Select.Option value="villas">Villas</Select.Option>
      <Select.Option value="locaux commerciaux">
        Locaux commerciaux
      </Select.Option>
      <Select.Option value="bureaux">Bureaux</Select.Option>
    </Select>
  </Form.Item>
);

export default ComposantsDeProjetFormItem;
